import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    Container,
    Divider,
    Typography,
    useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
    AccountBalanceWalletRounded,
    HistoryRounded,
    ReceiptLongRounded,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ChargeCreateInvoice from "./_ChargeCreateInvoice";
import _ChargeInvoices from "./_ChargeInvoices";
import IncreaseHistory from "../IncreaseListPeyment/IncreaseHistory";
import { toPriceWithComma } from "../../helper/utils";

const Charge = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const corporate = useSelector(({ corporate }) => corporate.corporate);
    const [refreshCode, setRefreshCode] = useState(0);

    const totalDeposit = corporate?.FinanceCorporate?.TotalDeposit || 0;

    return (
        <Container maxWidth="xl" sx={{ pt: 3, pb: 6 }}>
            <title>کیف‌پول و شارژ حساب | جیم‌پین سازمانی</title>

            {/* Executive Page Header */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 3.5,
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            width: 54,
                            height: 54,
                            borderRadius: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'primary.main',
                            color: '#fff',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        <AccountBalanceWalletRounded sx={{ fontSize: 32 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                            کیف‌پول و شارژ حساب سازمان
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            مدیریت موجودی و صدور پیش‌فاکتور
                        </Typography>
                    </Box>
                </Box>

                {/* Current Balance Badge */}
                <Box
                    sx={{
                        p: 1.5,
                        px: 2.5,
                        borderRadius: 3,
                        bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(45, 107, 226, 0.06)',
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(45, 107, 226, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                    }}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                        موجودی فعلی سازمان:
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 900, color: 'primary.main' }}>
                        {toPriceWithComma(totalDeposit)} <span style={{ fontSize: '0.8rem', fontWeight: 500 }}>تومان</span>
                    </Typography>
                </Box>
            </Box>

            {/* Top Section: Create Invoice & Pending Invoices */}
            <Grid container spacing={3} alignItems="flex-start" sx={{ mb: 4 }}>
                <Grid size={{ xs: 12, lg: 7 }}>
                    <_ChargeCreateInvoice refreshList={() => setRefreshCode(Math.random())} />
                </Grid>
                <Grid size={{ xs: 12, lg: 5 }}>
                    <_ChargeInvoices refreshCode={refreshCode} />
                </Grid>
            </Grid>

            {/* Bottom Section: Full Transaction History & Official PDF Invoices */}
            <Box sx={{ mt: 2 }}>
                <IncreaseHistory />
            </Box>
        </Container>
    );
};

export default Charge;
